'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'en-us': {
        ok: 'Ok',
        cancel: 'Cancel',
        delete: 'Delete',
        setting: 'Setting',
        settingToSort: 'Sorting setting',
        reset: 'Reset',
        clear: 'Clear',
        searchPlaceholder: 'Input conditions please'
    },
    'zh-cn': {
        ok: '确认',
        cancel: '取消',
        delete: '删除',
        setting: '设置',
        settingToSort: '排序设置',
        reset: '重置',
        clear: '清空',
        searchPlaceholder: '过滤搜索条件'
    },
    'zh-tw': {
        ok: '確認',
        cancel: '取消',
        delete: '刪除',
        setting: '設置',
        settingToSort: '排序設置',
        reset: '重置',
        clear: '清空',
        searchPlaceholder: '過濾搜索條件'
    },
    'es-es': {
        ok: '確認',
        cancel: '取消',
        delete: '刪除',
        setting: '設置',
        settingToSort: '排序設置',
        reset: '重置',
        clear: '清空',
        searchPlaceholder: '過濾搜索條件'
    },
    'jp-jp': {
        ok: '確認',
        cancel: '取消',
        delete: '削除',
        setting: '設置',
        settingToSort: '序列設定',
        reset: 'リセット',
        clear: '青空',
        searchPlaceholder: '検索条件を濾過する'
    },
    'ru-ru': {
        ok: 'подтверждение',
        cancel: 'отмена',
        delete: 'удалить',
        setting: 'настройки',
        settingToSort: 'Сортировка настройки',
        reset: 'замена',
        clear: 'очистить',
        searchPlaceholder: 'Фильтрация условия поиска'
    },
    'ko-kr': {
        ok: '확인',
        cancel: '취소',
        delete: '삭제',
        setting: '설치',
        settingToSort: '순위를 배열하다.',
        reset: '重置',
        clear: '그만큼',
        searchPlaceholder: '수색 조건을 여과하다.'
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-inter-dialog@0.0.46@@alicd/crui-inter-dialog/lib/local/index.js
// module id = 107
// module chunks = 0